import React from 'react'
import Fuse from 'fuse.js'
import { connect } from 'react-redux'
import { selectors as UsersSelectors } from 'data/users'
import classNames from 'classnames'
import SearcheableMultipleSelect from 'components/Utils/SearcheableMutlipleSelect'
import { CheckboxEmptyIcon, CheckMarkIcon } from 'components/Utils/Icons'
import UserRow from './UserRow'

function SearcheableUserSelect({ users, ...props }) {
  return (
    <SearcheableMultipleSelect
      items={users}
      renderRow={({ item: user, selected, onClick }) => {
        return (
          <div
            className={classNames(
              'flexbox flexbox-align-center padding-horizontal-medium pointer',
              {
                'background-shade-50': selected,
                'background-shade-45-on-hover background-shade-50-on-active': !selected,
              }
            )}
            style={{ height: 40, marginTop: 2, marginBottom: 2 }}
            key={user.id}
            onClick={onClick}
          >
            {selected ? (
              <CheckMarkIcon size={16} className="primary" />
            ) : (
              <CheckboxEmptyIcon size={16} className="shade-30" />
            )}
            <UserRow className="margin-left-normal" user={user} />
          </div>
        )
      }}
      getValueFromItem={({ id }) => id}
      itemsContainerProps={{
        style: {
          height: 335,
        },
      }}
      filterItems={(items, term) => {
        if (!term) {
          return items
        }
        const fuse = new Fuse(items, {
          shouldSort: true,
          threshold: 0.3,
          location: 0,
          distance: 100,
          maxPatternLength: 32,
          minMatchCharLength: 1,
          keys: ['username', 'displayName'],
        })
        return fuse.search(term)
      }}
      {...props}
    />
  )
}

export default connect(state => ({
  users: UsersSelectors.getCurrentOrganizationUsersAsArray(state),
}))(SearcheableUserSelect)
